import React from "react";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { ConfirmationDialogParams } from "../../../../components/Dialog/ConfirmationDialog/ConfirmationDialog";
import CustomDatePicker from "../../../../components/Input/CustomDatePicker";
import DescriptionFormType from "../models/Description.form";
import isDateBefore from "../../../../functions/isDateBefore.function";

const LABEL_DEFAULT = "Deadline";
const LABEL_APROE = "Deadline for Implementation";

interface DeadlineInputProps {
  deadline: string | null;
  disabled: boolean;
  disablePast: boolean;
  handleDirtyChange: () => void;
  isAproe?: boolean;
  setFieldValue: (field: string, value: unknown, shouldValidate?: boolean) => void;
  showConfirmationDialog: (params: ConfirmationDialogParams) => Promise<string>;
  values: DescriptionFormType;
}

const DeadlineInput: React.FC<DeadlineInputProps> = (props) => {
  const { deadline, disabled, disablePast, handleDirtyChange, isAproe, setFieldValue, showConfirmationDialog, values } =
    props;
  const handleChange = (newDate: MaterialUiPickersDate) => {
    if (isDateBefore(newDate, values.estimatedFinishingDate)) {
      showConfirmationDialog({
        text: (
          <>
            The selected deadline date is earlier than the estimated finishing date. Please check and/or contact the
            requester.
          </>
        ),
      })
        .then(() => {
          handleDirtyChange();
          setFieldValue("deadline", newDate);
        })
        .catch(() => {
          setFieldValue("deadline", deadline);
        });
    } else {
      handleDirtyChange();
      setFieldValue("deadline", newDate);
    }
  };

  return (
    <CustomDatePicker
      disabled={disabled}
      disablePast={disablePast}
      label={isAproe ? LABEL_APROE : LABEL_DEFAULT}
      value={values.deadline || null}
      onChange={handleChange}
    />
  );
};

export default DeadlineInput;
